import type * as pf from '@amirada/lib-shared'
import { utils } from '@amirada/lib-shared'
import type * as tp from '@base/utils/types'
import { useAppIndexStore } from '@base/stores/indexStore'
import { ut_capStore, ut_createParamDataString } from '@base/utils/utils'

export const useInitStore = defineStore('initStore', () => {
  const state: { [key: string]: pf.InitData } = reactive({})
  const indexStore = useAppIndexStore()
  const appConfig = useAppConfig()

  function cacheKey(paramData: tp.IParamData): string {
    return ut_createParamDataString(paramData)
  }

  function setInitData(paramData: tp.IParamData, data: pf.InitData): void {
    // Check country and language
    const rccoIndex: number = data.restData.rcco.findIndex(i => i.cod.toLowerCase() === paramData.rcco)
    const lcdaIndex: number = data.langData.findIndex(i => i.cod.toLowerCase() === paramData.lcda)

    if (rccoIndex === -1 || lcdaIndex === -1) {
      indexStore.setParamDataMutation({
        rcco: rccoIndex > -1 ? paramData.rcco : appConfig.defaultCountry,
        lcda: lcdaIndex > -1 ? paramData.lcda : appConfig.defaultLang,
        redirectpath: ' ',
      })
      return
    }

    // Set iso-code and the decimal + thousand separator (generic lib-shared helpers; they fall back
    // to ',' / '.' on an invalid or empty ISO 639 code).
    const iso639: string = data.langData[lcdaIndex]?.attrs?.ISO639 || ''
    paramData.iso639 = iso639
    paramData.decSep = utils.decimalSeparator(iso639)
    paramData.thpSep = utils.thousandSeparator(iso639)

    ut_capStore(state)
    state[cacheKey(paramData)] = data
  }

  function getInitData(paramData: tp.IParamData): pf.InitData | undefined {
    return state[cacheKey(paramData)]
  }

  return {
    state,
    getInitData,
    setInitData,
  }
})
